<template>
    <div id="displaycount" class="clearfix">
        <p class="resultcount">
            検索結果: <b>{{ hits }}</b
            >件中<b>{{ nowPage.start }}</b
            >-<b>{{ nowPage.end }}</b
            >件を表示
        </p>
    </div>
</template>

<script>
import {
    // toRefs,
    defineComponent,
} from "vue";

export default defineComponent({
    name: "ResultSummary",
    props: {
        hits: {
            type: Number,
            required: true,
        },
        nowPage: {
            type: Object,
            required: true,
        },
    },
});
</script>

<style>
#displaycount .resultcount {
    float: left;
    padding-left: 20px;
}
</style>
